import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';

interface DeleteItemButtonProps {
  onClick: () => void;
}

export default function DeleteItemButton({onClick}: DeleteItemButtonProps): JSX.Element {
  return (
    <Button
      buttonStyle={ButtonStyle.CIRCLE_ICON}
      className="u-small-spacing-left"
      icon="delete"
      onClick={onClick}
      size={ButtonSize.SMALL}
    />
  );
}
